import { ApiText } from "../api-text";
import { FileInfo } from '../file/file-info';
import { ReportType } from './report-type';
import { ChartType } from '@enums/chart-type.enum';
import { ReportVariation } from './report-variation';

export class ReportItem {
    group: number;

    reportType: ReportType;
    title: ApiText;
    file?: FileInfo;
    selectedVariationCode?: string;
    variations?: ReportVariation[];

    constructor(title: ApiText, displayType: ChartType, reportType: ReportType) {
        this.title = title;
        this.reportType = reportType;
        this.variations = [ new ReportVariation(displayType) ];
    }
}
